/* eslint-disable react/prop-types */
import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import fixTableCellWidth from 'utils/fixTableCellWidth'

export default function FullTableHeader() {
  return (
    <TableRow>
      <TableCell className="tablecell" style={fixTableCellWidth("150px")}>قلک</TableCell>
      <TableCell className="tablecell" style={fixTableCellWidth("150px")}>فرصت سرمایه گذاری</TableCell>
      <TableCell className="tablecell" style={fixTableCellWidth("150px")}>موجودی فرصت</TableCell>
      <TableCell className="tablecell" style={fixTableCellWidth("170px")}>حداقل موجودی قلک</TableCell>
      <TableCell className="tablecell" style={fixTableCellWidth("150px")}>برای تاریخ</TableCell>
      <TableCell className="tablecell" style={fixTableCellWidth("150px")}>ایجاد</TableCell>
    </TableRow>
  )
}
